import { EmailAction } from '../../../models/EmailType'
import { SelectOption } from '../../../components/SelectDropdown/SelectDropdown'

export const EMAIL_ACTION_LABELS: Record<EmailAction, string> = {
  doNotReply: 'Do not reply',
  generateReply: 'Generate reply',
  pushToDraft: 'Push to draft',
}

export const EMAIL_ACTION_OPTIONS: SelectOption[] = [
  { id: 'doNotReply', label: EMAIL_ACTION_LABELS['doNotReply'] },
  { id: 'generateReply', label: EMAIL_ACTION_LABELS['generateReply'] },
  { id: 'pushToDraft', label: EMAIL_ACTION_LABELS['pushToDraft'] },
]

export function formatUserEmailAction(effectiveAction: EmailAction, userAction?: EmailAction): string {
  return `${EMAIL_ACTION_LABELS[effectiveAction]} ${!userAction ? '(Default)' : ''}`.trim()
}
